import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DateAdapter } from "@angular/material/core";
import { LanguageService } from "./core/lang/language.service";
import { AuthService } from "@auth0/auth0-angular";
import { filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MaintenanceAlertService } from "./core/services/maintenance-alert.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  
  public static readonly DEV_PWD_KEY = 'devPassword';
  public static readonly DEV_PWD = 'M@g!Pall3t';
  public protectedAcces = environment.protectedAcces;
  
  private _destroyRef$ = inject(DestroyRef);
  
  public form: FormGroup<{
    devPassword: FormControl<string>
  }>;
  
  constructor(private readonly languageService: LanguageService,
              private readonly dateAdapter: DateAdapter<any>,
              private readonly authService: AuthService,
              private readonly maintenanceAlertService: MaintenanceAlertService
  ) {
    this.form = new FormGroup<{
      devPassword: FormControl<string>
    }>({
      devPassword: new FormControl<string>('')
    });
    this.languageService.onLanguageChange.subscribe((event) => this.dateAdapter.setLocale(event.lang));
  }
  
  ngOnInit() {
    this.loadScript(`https://maps.googleapis.com/maps/api/js?key=${environment.googleAPIKey}&libraries=places&language=fr&callback=Function.prototype`);
    this.handleSessionError();
  }
  
  public setDevPassword(): void {
    localStorage.setItem(
      AppComponent.DEV_PWD_KEY,
      this.form.get(AppComponent.DEV_PWD_KEY).value
    );
  }
  
  public get allowedAccess(): boolean {
    return (
      !this.protectedAcces ||
      localStorage.getItem(AppComponent.DEV_PWD_KEY) === AppComponent.DEV_PWD
    );
  }
  
  private loadScript(name: string) {
    return new Promise<void>((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = name;
      document.getElementsByTagName('head')[0].appendChild(script);
      resolve()
    });
  }
  
  
  private handleSessionError(): void {
    this.authService.error$.pipe(
      takeUntilDestroyed(this._destroyRef$),
      filter((err: any) => (err?.error === 'login_required' || err?.error === 'consent_required'))
    ).subscribe(() => this.authService.loginWithRedirect({
        appState: { justLoggedIn: true },
        authorizationParams: {
          ui_locales: this.languageService.currentLanguage,
          redirect_uri: window.location.origin,
          'ext-signup_url': `${window.location.origin}/onboarding`,
        }
      })
    );
  }
}
